import { MenuOptionGroup, type MenuOptionGroupProps } from '@chakra-ui/react';

export type UiMenuOptionGroupProps = MenuOptionGroupProps;

export const UiMenuOptionGroup = MenuOptionGroup;
